import RestService from '../services/rest';

async function getAbandonedItems(initialDate, finalDate) {
  return RestService.getAuthenticated(
    `panel/abandoned?isFiltering=${true}&initialDate=${initialDate}&finalDate=${finalDate}`,
  );
}

async function sendEmail(userId, type, clientId = '') {
  return RestService.postAuthenticated(`panel/abandoned/sendEmail?userId=${userId}&type=${type}&clientId=${clientId}`);
}

async function getCsvAbandonedReport(initialDate, finalDate, combinedData, isFiltered) {
  const response = await RestService.putAuthenticated(
    `panel/abandoned/report/csv?initialDate=${initialDate}&finalDate=${finalDate}`,
    {
      responseType: 'blob',
      combinedData,
      isFiltered,
    },
  );
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'abandoned-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

export default {
  getAbandonedItems,
  sendEmail,
  getCsvAbandonedReport,
};
